import { memo } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import CarrierLogo from './carrier-logo';
import style from './carrier-logo-column.module.less';

const defaultDataDrivenLogoProps = {};

/**
 * @typedef {import('../../../prop-types/intl-types').MessageDescriptor} MessageDescriptor
 */

/**
 * @typedef {object} DataDrivenLogoProps
 * @property {number} [providerId]
 * @property {number} [carrierId]
 */

/**
 * @param {object} props
 * @param {MessageDescriptor|string} [props.message]
 * @param {boolean} [props.isMultiple]
 * @param {boolean} [props.isEmpty]
 * @param {DataDrivenLogoProps} [props.dataDrivenLogoProps]
 * @returns {React.JSX.Element}
 */
const CarrierLogoColumn = ({ message, isMultiple = false, isEmpty = false, dataDrivenLogoProps = defaultDataDrivenLogoProps }) => {
  const isEmptyOrHasNoProps = isEmpty || Object.keys(dataDrivenLogoProps).length === 0;
  return (
    <div
      className={classnames(style['third-party-logo-column'], {
        [style.multiple]: isMultiple,
      })}
    >
      {!isEmptyOrHasNoProps && isMultiple ? (
        <FormattedMessage defaultMessage='(Multiple)' description='thirdPartyLogoColumn.multiple' id='GQLoY+' />
      ) : null}
      {!isEmptyOrHasNoProps && !isMultiple && (
        <div className={style['normal-content']}>
          <CarrierLogo className={style['data-driven-logo']} logoType='icon' {...dataDrivenLogoProps} />
          <div className={style.message}>{typeof message === 'string' ? message : <FormattedMessage {...message} />}</div>
        </div>
      )}
    </div>
  );
};

export default memo(CarrierLogoColumn);
